import { NavigationComponent } from 'navigation-components/consumer/components';
import TeaseNotificationContainerWithProvider from './TeaseNotificationContainerWithProvider';
import { teaseNotificationsComponentDef } from 'navigation-components/config';
import { isHealthCheck } from '../../utils/isHealthCheck';
import { jsx as _jsx } from "react/jsx-runtime";
const TeaseNotificationsComponent = () => /*#__PURE__*/_jsx(NavigationComponent, {
  enableStandaloneMode: isHealthCheck,
  definition: teaseNotificationsComponentDef,
  component: TeaseNotificationContainerWithProvider,
  definitionParams: {
    gates: []
  }
});
export default TeaseNotificationsComponent;